export function findAreaPath(arr, id) {
    let path = [];
    let Area = '';
    let PathArea = {};
    if (id == '') {
        return path;
    }
    arr.forEach((item, index, arr) => {
        if(item.length < 3) {
            // 国内、其他
            if (item[0] == id) {
                path = [id, id, id];
                Area = item[1];
            }
        } else {
            // 一级城市
            if (item[0] == id) {
                path = [id, id, id];
                Area = item[1];
            } else {
                item[2].forEach(second => {
                    if (second.length > 2) {
                        // 3级
                        if (second[0] == id) {
                            if (item[0] == 2) {// 国外
                                path = [second[0], second[0], second[0]];
                                Area = [second[1],second[1],second[1]];
                            } else {
                                path = [item[0], second[0], second[0]];
                                Area = [item[1],second[1],second[1]];
                            }
                        }
                        second[2].forEach(third => {
                            if (third[0] == id) {
                                if (item[0] == 2) {
                                    path = [second[0], second[0], third[0]];
                                    Area = [second[1],second[1],third[1]];
                                } else {
                                    path = [item[0], second[0], third[0]];
                                    Area = [item[1], second[1],third[1]];
                                }
                            }
                        });
                    } else if (second[0] == id) {
                        if (item[0] == 2) {
                            // 国外
                            path = [second[0], second[0], second[0]];
                            Area = [second[1],second[1],second[1]];
                        } else {
                            path = [item[0], item[0], second[0]];
                            Area = [item[1],item[1],second[1]];
                        }
                    }
                });
            }
        }
    });
    return Object.assign(PathArea, { path: path },{ Area: Area });
}


// WEBPACK FOOTER //
// ./src/components/Field_Components/PopArea/findAreaPath.js